import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Unauthorized() {
  const { t, ready } = useTranslation(null, { useSuspense: false });

  if (!ready) {
    return null;
  }

  return (
    <div id="global-layer-main" className="container viewport-constraint-inherit">
      <div id="global-layer-main-content">
        <div className="member-diamonds-conversion">
          <h4>{t('unauthenticated_please_close_window')}</h4>
          <p>{t('unauthenticated_description')}</p>
        </div>
      </div>
    </div>
  );
}
